import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8425288c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=8425288c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8425288c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonAreaCascadeEnhance: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/common/areaCascadeEnhance.vue').default})
